module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n  <div class="form-group col-3">\r\n    <label for="code">'+
((__t=(i18n.t("common:selecteuractivites.dlgcode")))==null?'':__t)+
'</label>\r\n    <input type="text" class="code form-control" value="" size="15" maxlength="15" />\r\n  </div>\r\n  <div class="form-group col-9">\r\n    <label for="libelle">'+
((__t=(i18n.t("common:selecteuractivites.dlglibelle")))==null?'':__t)+
'</label>\r\n    <input type="text" class="libelle form-control" value="" size="25" maxlength="60" />\r\n  </div>\r\n  <div class="hierTypeFilterFields form-group col-9 d-none"></div>\r\n';
}
return __p;
};
